// `dark` disables to near-white on near-white, and `disabled:opacity-50` then fades it again.
export const DISABLED_LEGIBLE =
  'disabled:!bg-foreground/55 disabled:!text-background disabled:opacity-100';
